import App from "./App";
import { Login, LoginWithOtp, Register, OtpVerification } from "./auth";
import { Projects, Project } from "./project";
import ErrorPage from "./error-page";
import { Catalogs, NewPersonalize, ProductPersonalize } from "./product";
import CatalogPage from "./catalog/CatalogPage";
import {
  ComingSoon,
  CutlistPromo,
  Modules,
  LandingPage,
  PricingPage,
  LandingPage1,
  PreviewPage,
  Support,
  Organizations,
  Laminates,
  LaminateCatalog,
} from "./common";
import { Order, Orders } from "./order";
import OrderCutlist from "./order/OrderCutlist";
import PriceSummary from "./project/PriceSummary";
import LabelPrinting from "./project/LabelPrinting";
import CuttingPlan from "./project/CuttingPlan";
import Assembly from "./project/Assembly";
import Sourcing from "./ops-tracker/Sourcing";
import AddOns from "./common/AddOns";
import HomePage from "./home/HomePage";
import SampleOrdersPage from "./sample_projects/SampleOrdersPage";
import SalesDashboard from "./sales/pages/SalesDashboard";
import ProspectEngagement from "./sales/pages/ProspectEngagement";
import OpsDashboard from "./dashboards/ops/pages/OpsDashboard";
import NotificationsPage from "./dashboards/NotificationsPage";
import ProductCatalog from "./catalog/ProductCatalog";
import Broadcasts from "./sales/pages/Broadcasts";
export const routes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "verify_otp",
        element: <OtpVerification />,
      },
      {
        path: "login_with_otp",
        element: <LoginWithOtp />,
      },
      {
        path: "admin_login",
        element: <Login user="admin" />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "catalog",
        element: <Catalogs />,
      },
      {
        path: "catalog-collection",
        element: <CatalogPage />,
      },
      {
        path: "sample-orders",
        element: <SampleOrdersPage />,
      },
      {
        path: "laminates",
        element: <LaminateCatalog />,
      },
      {
        path: "projects/:projectId",
        element: <Project />,
        children: [
          { path: "cutlist", element: <></> },
          { path: "settings", element: <NewPersonalize /> },
          { path: "packages", element: <ComingSoon /> },
          {
            path: "orders/:orderId",
            element: <Order />,
            children: [
              { path: "bom", element: <PriceSummary /> },
              { path: "optimization", element: <CuttingPlan /> },
              { path: "cutlists", element: <OrderCutlist /> },
              { path: "panels", element: <LabelPrinting /> },
            ],
          },
          { path: "shipments", element: <ComingSoon /> },
          { path: "payments", element: <ComingSoon /> },
          {
            path: "rooms/:roomId/modules/:moduleId/canvas",
            element: <NewPersonalize />,
          },
          { path: "rooms/:roomId/canvas", element: <NewPersonalize /> },
          { path: "assembly", element: <Assembly /> },
          { path: "materials", element: <NewPersonalize /> },
        ],
      },
      {
        path: "projects/:projectId/add_ons",
        element: <AddOns />,
      },
      {
        path: "cutlist-promo",
        element: <LandingPage />,
      },
      {
        path: "ops",
        element: <Sourcing />,
      },
      {
        path: "cl",
        element: <CutlistPromo />,
      },
      {
        path: "cl/:productId",
        element: <CutlistPromo />,
      },
      {
        path: "modules",
        element: <Modules />,
      },
      {
        path: "modules/:productId",
        element: <ProductPersonalize />,
      },
      {
        path: "pricing/682e7cc359d9",
        element: <PricingPage />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "admin",
        element: <Organizations />,
      },
      {
        path: "manage_laminates",
        element: <Laminates />,
      },
      {
        path: "home/landing-1",
        element: <LandingPage1 />,
      },
      {
        path: "sales/dashboard",
        element: <SalesDashboard />,
      },
      {
        path: "sales/engagement",
        element: <ProspectEngagement />,
      },
      {
        path: "sales/broadcasts",
        element: <Broadcasts />,
      },
      {
        path: "dashboard/ops",
        element: <OpsDashboard />,
      },
      {
        path: "home",
        element: <HomePage />,
      },
      {
        path: "demo",
        element: <PreviewPage />,
      },
      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "products",
        element: <ProductCatalog />,
      },
    ],
    errorElement: <ErrorPage />,
  },
];
